import React, { useState, useEffect, useRef } from "react";
import "./Placeholder.css";
import emailjs, { send } from "@emailjs/browser";

function ContactForm() {
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    message: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const [isSubmitted, setIsSubmitted] = useState(false);
  const form = useRef();

  const sendEmail = (e) => {
    e.preventDefault();

    emailjs.sendForm("service_zs8574r", "template_00xt1ya", form.current, "9c4lTNyX9AlMOAJ_9").then((result) => {
        console.log(result.text);
        setIsSubmitted(true); // Update the state to indicate successful submission
    }, (error) => {
        console.log(error.text);
    });
  };
  
  return (
    <form ref={form} onSubmit={sendEmail}>
       {isSubmitted ? (<h2>Thank you for your message!</h2>) : ( <div>
            <label><strong>Name (required)</strong></label>
            <div className="inline-input">
                <input type="text" name="firstName" placeholder="First" value={formData.firstName} onChange={handleChange} required></input>
                <input type="text" name="lastName" placeholder="Last" value={formData.lastName} onChange={handleChange} required></input>
            </div>
            <label><strong>Email Address</strong></label>
            <div className="inline-input">
                <input type="email" name="email" placeholder="Email Address" value={formData.email}onChange={handleChange} required></input>
            </div>
            <label><strong>Message</strong></label>
            <div className="inline-input">
                <input name="message" placeholder="Message" value={formData.message} onChange={handleChange} required></input>
            </div>
            <button type="submit">Submit</button>
        </div>)}
    </form>
    );
}

const Placeholder = () => {
  return (
    <div className="section">
      <div className="container">
        <h1>Hello There!</h1>
        <p>
          Thank you for joining us on this exciting journey! At Springboard, we
          are committed to building an equitable space where clients and talent
          come together through a shared passion for creating innovative
          products with cutting-edge technology.
        </p>
        <p>
          While our site is still in development, we invite you to reach out if
          you're interested in our web and software design services, or if you'd
          like to stay updated on our progress. Simply fill out the contact form
          below, and we'll be in touch!
        </p>
        <div style={{height: "50px"}}></div>
        <ContactForm></ContactForm>
      </div>
    </div>
  );
};

export default Placeholder;
